import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-deals',
  template: `
    <p>
      deals works!
    </p>
  `,
  styles: [
  ]
})
export class DealsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
